"use client";

import { MantineProvider as MantineProviderBase } from '@mantine/core';
import { ReactNode } from 'react';

interface MantineProviderProps {
  children: ReactNode;
}

export function MantineProvider({ children }: MantineProviderProps) {
  return (
    <MantineProviderBase
      theme={{
        // Use your existing design system colors
        colors: {
          // Map your existing colors to Mantine's color system
          primary: ['#f0f9ff', '#e0f2fe', '#bae6fd', '#7dd3fc', '#38bdf8', '#0ea5e9', '#0284c7', '#0369a1', '#075985', '#0c4a6e'],
        },
        // Use your existing font family
        fontFamily: 'Inter, system-ui, sans-serif',
        // Use your existing font sizes
        fontSizes: {
          xs: '0.75rem',
          sm: '0.875rem',
          md: '1rem',
          lg: '1.125rem',
          xl: '1.25rem',
        },
        // Use your existing spacing
        spacing: {
          xs: '0.5rem',
          sm: '0.75rem',
          md: '1rem',
          lg: '1.5rem',
          xl: '2rem',
        },
        // Use your existing border radius
        radius: {
          xs: '0.125rem',
          sm: '0.25rem',
          md: '0.375rem',
          lg: '0.5rem',
          xl: '0.75rem',
        },
        // Use your existing shadows
        shadows: {
          xs: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
          sm: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
          md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
          lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
          xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
        },
        // Configure z-index values following Mantine best practices
        other: {
          zIndices: {
            modal: 1000, // Higher z-index for modals
            overlay: 999, // Slightly lower than modal
            drawer: 1000, // Same as modal for consistency
            popover: 400, // Lower z-index for popovers
            tooltip: 1200, // Higher than popovers
            notification: 1300, // Highest for notifications
          },
        },
      }}
    >
      {children}
    </MantineProviderBase>
  );
}
